import { ttsPreferencesStorage } from '../storage';
import isSSML from '../utils/isSSML';
import { isWebView } from 'src/utils/platform';
import { WebRNModuleAPIs } from 'src/components/15-containers/SuperChargedWebView/communication/web2RNCom/WebRNModuleAPIs';
const VOICES_POLL_MS = 50;
const VOICES_TIMEOUT_MS = 2000;
function isSpeechSynthesisAvailable() {
    return (typeof window !== 'undefined' &&
        typeof speechSynthesis !== 'undefined' &&
        typeof SpeechSynthesisUtterance !== 'undefined');
}
const TTS = isWebView
    ? WebRNModuleAPIs.TTS
    : {
        async init() { },
        async speak(text, options = {}) {
            if (!isSpeechSynthesisAvailable()) {
                return;
            }
            const utterance = new SpeechSynthesisUtterance();
            const { voiceId = ttsPreferencesStorage.getVoiceId(), rate = ttsPreferencesStorage.getRate(), hooks, } = options;
            if (voiceId) {
                const voice = await TTS.getMatchingVoice(voiceId);
                if (voice) {
                    utterance.voice = voice?.voice;
                }
            }
            // Since SSML text would already contain the `rate`, we can safely ignore
            // the rate parameter and set a dummy rate
            if (!isSSML(text) && rate && rate > 0) {
                utterance.rate = rate;
            }
            utterance.text = text;
            utterance.addEventListener('end', () => {
                hooks?.onEnd?.();
            });
            utterance.addEventListener('error', () => {
                hooks?.onSkip?.();
            });
            // utterance.addEventListener('pause', () => {
            //   console.log('Utterance Pause');
            // });
            // utterance.addEventListener('resume', () => {
            //   console.log('Utterance Resume');
            // });
            // utterance.addEventListener('start', () => {
            //   console.log('Utterance Start');
            // });
            speechSynthesis.speak(utterance);
        },
        async pause() {
            if (!isSpeechSynthesisAvailable()) {
                return;
            }
            speechSynthesis.pause();
        },
        async resume() {
            if (!isSpeechSynthesisAvailable()) {
                return;
            }
            speechSynthesis.resume();
        },
        async stop() {
            if (!isSpeechSynthesisAvailable()) {
                return;
            }
            speechSynthesis.cancel();
        },
        async getVoices() {
            if (!isSpeechSynthesisAvailable()) {
                return [];
            }
            const voices = await new Promise(resolve => {
                const startedAt = Date.now();
                const timer = setInterval(() => {
                    const _voices = speechSynthesis.getVoices();
                    if (_voices.length > 0) {
                        clearInterval(timer);
                        resolve(_voices);
                        return;
                    }
                    if (Date.now() - startedAt >= VOICES_TIMEOUT_MS) {
                        clearInterval(timer);
                        resolve([]);
                    }
                }, VOICES_POLL_MS);
            });
            return voices
                .filter(voice => voice.lang.startsWith('en'))
                .map((voice) => ({
                language: voice.lang,
                name: voice.name,
                id: voice.voiceURI,
                voice,
            }));
        },
        async getMatchingVoice(voiceId) {
            const voices = await TTS.getVoices();
            return voices.find(voice => voice.id === voiceId);
        },
        async isSupported() {
            return isSpeechSynthesisAvailable();
        },
    };
export default TTS;
